import React from "react";
import { MessageSquare, PenLine, SlidersHorizontal, Check, Radio } from "lucide-react";

const STEPS = [
  { icon: MessageSquare, title: "Discover", body: "We meet, listen, and learn your story. We dig into your brand vision, audience, competitors, and tone. Out of this discovery comes the creative brief that guides everything." },
  { icon: PenLine, title: "Create", body: "Our writers and composers craft original lyrics, melodies, and arrangements aligned to your brand. You'll see drafts and demos along the way." },
  { icon: SlidersHorizontal, title: "Produce", body: "Studio recording with professional vocalists and musicians. Mixing and mastering give your song that radio-ready polish." },
  { icon: Check, title: "Refine", body: "We share variations for your review. We polish, tweak, and adjust until every detail represents your brand perfectly." },
  { icon: Radio, title: "Deliver", body: "Approved variations are unlocked in your dashboard. Download MP3, WAV, lyrics PDF, and commercial license — ready to roll." },
];

export default function Process() {
  return (
    <div className="bg-black">
      <div className="container-x section">
        <div className="text-center mb-16">
          <div className="eyebrow mb-3">Our Process</div>
          <h1 className="font-heading text-4xl md:text-5xl">How A Songniture Is Born</h1>
        </div>
        <div className="max-w-3xl mx-auto">
          {STEPS.map((s, i) => (
            <div key={s.title} className="flex gap-6 pb-12 last:pb-0 relative" data-testid={`process-detail-${i + 1}`}>
              {i < STEPS.length - 1 && <div className="absolute top-14 left-7 w-px h-full border-l border-dashed border-gold/40" />}
              <div className="w-14 h-14 rounded-full bg-black border-2 border-gold flex items-center justify-center text-gold font-heading text-xl font-bold shrink-0 shadow-gold">
                {i + 1}
              </div>
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <s.icon className="text-gold" size={22} />
                  <h3 className="font-heading text-2xl">{s.title}</h3>
                </div>
                <p className="text-white/70 leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
